import store from '@/vuex/store';

export function getContentProvider() {
    return store.getters.selectedServiceAccount;
}
